import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import SearchBar from "components/app/search-bar/SearchBar";
import { LoaderCircle, X } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "components/app/dialog/dialog";

import InfiniteScroll from "react-infinite-scroll-component";
import { useEffect } from "react";

interface DialogProps {
  isDialogAddUserOpen: boolean;
  setIsDialogAddUserOpen: (value: boolean) => void;
  filteredUsers: any;
  setSearchUserInput: (value: string) => void;
  setActiveTab: (value: string) => void;
  setUserClicked: any;
  fetchMorePermissionSearchUser: any;
  accountLoading: any;
}

export default function DialogAddUserPermission({
  isDialogAddUserOpen,
  setIsDialogAddUserOpen,
  filteredUsers,
  setSearchUserInput,
  setActiveTab,
  setUserClicked,
  fetchMorePermissionSearchUser,
  accountLoading,
}: DialogProps) {
  return (
    <Dialog open={isDialogAddUserOpen}>
      <DialogContent className="" isShowBtnXClose={false}>
        <DialogHeader>
          <DialogTitle>Add User Permission</DialogTitle>
          <DialogDescription>
            Search the user's name to send the shop permission request.
          </DialogDescription>
          <div
            className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
            onClick={() => {
              setIsDialogAddUserOpen(false);
              setSearchUserInput("");
            }}
          >
            <X />
          </div>
        </DialogHeader>
        <div>
          <SearchBar
            placeholder="Find user"
            onValueChange={(value) => setSearchUserInput(value)}
            className="pb-2"
          />

          {filteredUsers ? (
            <div
              id="scrollableDiv2"
              className="h-[500px] overflow-y-auto custom-scrollbar"
            >
              <InfiniteScroll
                className={`relative h-[500px]`}
                dataLength={filteredUsers["data"]?.length}
                next={() =>
                  fetchMorePermissionSearchUser({
                    next: accountLoading.nextPageUrl,
                  })
                }
                scrollThreshold="90%"
                hasMore={!!accountLoading.nextPageUrl}
                scrollableTarget="scrollableDiv2"
                loader={
                  <div className="absolute bottom-2 left-0 w-full flex justify-center">
                    <LoaderCircle
                      size={30}
                      className="animate-spin text-yellow-400"
                    />
                  </div>
                }
                endMessage={
                  <p className="absolute bottom-0 left-0 w-full text-center">
                    <b>Nothing more to load!</b>
                  </p>
                }
              >
                <div className="grid grid-cols-1 gap-4 mb-16">
                  {filteredUsers?.data?.map((item: any) => (
                    <div
                      key={item.id}
                      onClick={() => {
                        setActiveTab("tap");
                        setUserClicked(item);
                        setIsDialogAddUserOpen(false);
                      }}
                      className="p-4 cursor-pointer flex items-center hover:bg-slate-100"
                    >
                      <ImageUrlProfile
                        className="w-[50px] h-[50px] border rounded-full object-cover"
                        user={item}
                        alt="page"
                      />
                      <div className="ml-4">
                        <p className="font-medium line-clamp-1">{item.name}</p>
                        <p className="text-sm text-gray-500 line-clamp-1">
                          {item.bio}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </InfiniteScroll>
            </div>
          ) : (
            <></>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
